import React, { FC } from "react";

import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { BookingLabelsDto } from "@apiModels/BookingLabelsDto.csharp";
import classNames from "classnames";

type PriceDetailsButtonProps = {
  service: ServiceContainerDto;
  bookingLabels: BookingLabelsDto;
  buttonCss?: string;
  onClick: () => void;
}; 

export const PriceDetailsButton: FC<PriceDetailsButtonProps> = ({
  service,
  bookingLabels,
  buttonCss,
  onClick,
}) => {
  const label =
    service.priceDetailsLabel || bookingLabels.commonLabels.priceDetailsLabel;

  return (
    <button className={classNames("PriceDetailsButton", buttonCss)} onClick={onClick}>
      {label}
    </button>
  );
};
